export default __webpack_public_path__ + "static/media/icon_map_pin.fefc16b3.svg";